import Link from 'next/link';
import React from 'react';
import { colors } from '../utils/theme';
import { ImFacebook2, ImLinkedin } from 'react-icons/im';
import { FaInstagram } from 'react-icons/fa';
import Image from 'next/image';
import { useRouter } from 'next/router';
import getAmplitude from '../utils/amplitude';

const renderFooter = () => {
  return (
    <div className="w-full overflow-hidden flex items-center" style={{ backgroundColor: colors.green }}>
      <div className="ml-auto mr-auto max-w-screen-xl flex w-full flex-col md:flex-row  pt-4 pb-4 md:pt-4 md:pb-4 pl-6 pr-6">
        <div className="w-full md:w-1/3 flex items-center relative justify-center md:justify-start">
          <Link href={'/'} prefetch={false}>
            <Image
              className="cursor-pointer self-center w-[120px] h-[50px] my-4 mx-0"
              onClick={async () => {
                const amplitude = await getAmplitude();
                amplitude.logEvent('Clicked on xplore navbar logo');
                localStorage.removeItem('lastDownloadReminder');
              }}
              width={120}
              height={50}
              src="/xploreLogo.png"
              alt={''}
            />
          </Link>
        </div>

        <div className="w-full md:w-1/3 mt-8 flex flex-col items-center justify-center">
          <div className="flex flex-col">
            <Link href={`/privacy-policy`} passHref prefetch={false}>
              <a
                className="text-white font-normal cursor-pointer mb-3.5 p-2"
                onClick={async () => {
                  const amplitude = await getAmplitude();
                  amplitude.logEvent('Clicked on privacy policy');
                }}>
                Privacy policy
              </a>
            </Link>
            <Link href={`/terms-and-conditions`} passHref prefetch={false}>
              <a
                className="text-white font-normal cursor-pointer mb-3.5 p-2"
                onClick={async () => {
                  const amplitude = await getAmplitude();
                  amplitude.logEvent('Clicked on terms & conditions');
                }}>
                Terms & Conditions
              </a>
            </Link>
            <Link href={`https://xplorelocal.ie/`} passHref prefetch={false}>
              <a
                className="text-white font-normal cursor-pointer mb-3.5 p-2"
                onClick={async () => {
                  const amplitude = await getAmplitude();
                  amplitude.logEvent('Clicked on https://xplorelocal.ie/');
                }}>
                Interested in Xplore?
              </a>
            </Link>
            <Link href={`https://upourside.com/`} passHref prefetch={false}>
              <a className="text-white font-normal cursor-pointer mb-3.5 p-2">Built by Ourside</a>
            </Link>
          </div>
        </div>

        <div className="w-full md:w-1/3 mt-8 flex flex-col items-center justify-center">
          <div className="flex items-center  justify-evenly md:justify-center w-full">
            <Link href={`https://www.facebook.com/goxplorelocal`} passHref prefetch={false}>
              <a>
                <div style={{ borderRadius: 100, backgroundColor: colors.white }}>
                  <ImFacebook2 style={{ cursor: 'pointer', padding: 8, fontSize: 42, color: colors.green }} />
                </div>
              </a>
            </Link>

            <Link href={`https://www.linkedin.com/company/74616964`} passHref prefetch={false}>
              <a>
                <div className="ml-4 mr-4" style={{ borderRadius: 100, backgroundColor: colors.white }}>
                  <ImLinkedin style={{ cursor: 'pointer', padding: 8, fontSize: 42, color: colors.green }} />
                </div>
              </a>
            </Link>

            <Link href={`https://www.instagram.com/go.xplore.local`} passHref prefetch={false}>
              <a>
                <div style={{ borderRadius: 100, backgroundColor: colors.white }}>
                  <FaInstagram style={{ cursor: 'pointer', padding: 8, fontSize: 42, color: colors.green }} />
                </div>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const Footer = ({ forceRender = false }) => {
  const router = useRouter();
  if (forceRender) return renderFooter();
  if (router.pathname.includes('/listings')) return null;
  return renderFooter();
};

export default Footer;
